const c = {
  name: "Graph2",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34,0c-2.2,0-4,1.8-4,4c0,0.7,0.2,1.4,0.6,2L26,10.6c-0.6-0.4-1.3-0.6-2-0.6c-1.3,0-2.5,0.6-3.2,1.6L18,10.5
			c0-0.2,0-0.3,0-0.5c0-2.2-1.8-4-4-4c-1.6,0-3,0.9-3.6,2.3L8,7.8C7.9,5.7,6.1,4,4,4C1.8,4,0,5.8,0,8c0,2.2,1.8,4,4,4
			c1.6,0,3-0.9,3.6-2.3l2.4,0.5c0.1,2.1,1.9,3.8,4,3.8c1.3,0,2.5-0.6,3.2-1.6l2.8,1.1c0,0.2,0,0.3,0,0.5c0,2.2,1.8,4,4,4
			c2.2,0,4-1.8,4-4c0-0.7-0.2-1.4-0.6-2L32,7.4C32.6,7.8,33.3,8,34,8c2.2,0,4-1.8,4-4S36.2,0,34,0z M32,4c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2s-0.9,2-2,2C32.9,6,32,5.1,32,4z M4,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S2,9.1,2,8S2.9,6,4,6z M12,10c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C12.9,12,12,11.1,12,10z M24,12c1.1,0,2,0.9,2,2s-0.9,2-2,2c-1.1,0-2-0.9-2-2S22.9,12,24,12z"/>
		<path class="st0" d="M3,40V15h2v25H3z"/>
		<path class="st0" d="M13,17v23h2V17H13z"/>
		<path class="st0" d="M33,40V11h2v29H33z"/>
		<path class="st0" d="M23,21v19h2V21H23z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Graph2
};
